import React, { Component } from "react"
import { Button } from "../components/Button"
import { FormattedMessage } from "react-intl"
import "./css/SearchForm.css"

export class SearchForm extends Component {
  submitForm = event => {
    event.preventDefault()
    this.props.fetch(0)
  }

  groupByIndex = searchFields => {
    let groups = [];
    let fields = [];

    searchFields.forEach((f, i) => {
      fields.push(f);
      if (fields.length === 2 || i === searchFields.length - 1) {
        groups.push({ fields: [...fields] });
        fields = [];
      }
    });

    return groups
  }

  renderSearchField = (searchField, i) => {
    const field = (
      <div key={`field_${i}`} className='searchInputContainer'>
        <label>
          <FormattedMessage id={searchField.label} />
          {searchField.component}
        </label>
      </div>
    )
    return field
  }

  renderSearchFieldGroups = groups => {
    return groups.map((group, i) => {
      return (
        <div key={`group_${i}`} className='searchControls'>
          {group.fields.map(this.renderSearchField)}
        </div>
      )
    })
  }

  render() {
    const { isFormValid, searching, searchFields, resetForm } = this.props

    return (
      <form className='searchForm' onSubmit={this.submitForm}>
        {this.renderSearchFieldGroups(this.groupByIndex(searchFields))}
        <div className='searchButtonContainer'>
          <div className='validatorMessage' role='alert'>
            {!!!isFormValid() && <FormattedMessage id='operatorSearch.inputError' />}
          </div>
          <Button className='clearLink' onClick={resetForm}>
            <FormattedMessage id='common.clearForm' />
          </Button>
          <Button
            className='searchButton'
            type='submit'
            primary
            search
            disabled={searching || !isFormValid()}
          >
            <FormattedMessage id='common.search' />
          </Button>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchForm.js